export default "__VITE_ASSET__DHqqds2D__"